export enum UserType {
    CUSTOMER = 'CUSTOMER',
    SUPPLIER = 'SUPPLIER',
    ADMIN = 'ADMIN',
    SYSTEM = 'SYSTEM',
}
